export default __webpack_public_path__ + "static/media/soham.5947e44e.jpg";